import {
  validatePassword,
  validateEmail,
  validatePhone,
  validateDisplayName,
} from "../utils/validation";

export const shouldShowSignupFieldError = (
  field,
  { touched = {}, submitAttempted = false } = {}
) => Boolean(submitAttempted || touched[field]);

export const collectSignupFieldErrors = (
  formData,
  { showTerms = false, acceptedTerms = false } = {}
) => {
  const newErrors = {};
  const displayName = formData?.displayName || "";
  const email = formData?.email || "";
  const phone = formData?.phone || "";
  const password = formData?.password || "";
  const confirmPassword = formData?.confirmPassword || "";

  const displayNameValidation = validateDisplayName(displayName);
  if (!displayNameValidation.isValid) {
    newErrors.displayName = displayNameValidation.error;
  }

  const emailValidation = validateEmail(email);
  if (!emailValidation.isValid) {
    newErrors.email = emailValidation.error;
  }

  const phoneValidation = validatePhone(phone);
  if (!phoneValidation.isValid) {
    newErrors.phone = phoneValidation.error;
  }

  if (!password) {
    newErrors.password = "Password is required";
  } else {
    const passwordValidation = validatePassword(password);
    if (!passwordValidation?.isValid) {
      newErrors.password = passwordValidation?.errors;
    }
  }

  if (password !== confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match";
  }

  if (showTerms && !acceptedTerms) {
    newErrors.terms = "You must accept the terms and conditions";
  }

  return newErrors;
};

export const visibleSignupFieldErrors = (
  allErrors,
  { touched = {}, submitAttempted = false } = {}
) => {
  const visible = {};
  Object.entries(allErrors || {}).forEach(([field, error]) => {
    if (error && shouldShowSignupFieldError(field, { touched, submitAttempted })) {
      visible[field] = error;
    }
  });
  return visible;
};
